import styled from "@emotion/styled";
import { Button } from "@mui/material";
import { useOneLinkUrl } from "contexts/OneLinkScript";
import Link from "next/link";
import { useEffect } from "react";
import { TrackMapSource, trackDownloadApp, trackEventByNameAndCategory } from "reusable/ChargeGTM";
import { Mobile } from "ui";
import { sharedColors } from "ui/theme/colors";

const StyledButtonWrapper = styled.div<{ adjustedPosition: number }>`
position: fixed;
bottom: ${(p) => p.adjustedPosition}px;
width: 100%;
height: 65px;
gap: 10px;
opacity: 0px;
z-index: 1000;
display: flex;
justify-content: center;
align-items: center;
box-shadow: 0px -4px 20px 0px #00000012;
background: #FFFFFF66;
padding-left: 10px;
padding-right: 10px;
`
const StyledButtonYellow = styled(Button)`
height: 45px;
padding: 17px 16px 17px 16px;
gap: 12px;
border-radius: 40px;
opacity: 0px;
background: #FFFFFF;
border: 2px solid #000000;
color: black;
width: 172px;
  &:hover {
    background: #FFFFFF; /* Ensure the background color remains the same on hover */
  }
`
const StyledButton = styled(Button)`
  background-color: ${sharedColors.blue};
  height: 45px;
  width: 172px;
  border-radius: 40px;
  :hover {
    background-color: ${sharedColors.blue};
  }
`

type Props = {
  adjustedPosition?: number
}
function StickyButtonNav({ adjustedPosition = 0 }: Props) {
  const { oneLinkUrl } = useOneLinkUrl()

  useEffect(() => {
    if (oneLinkUrl) {
      console.log("oneLinkUrl", oneLinkUrl)
    }
  }, [oneLinkUrl])
  return (
    <Mobile>
      <StyledButtonWrapper
        adjustedPosition={adjustedPosition}>
        <Link href={"/pazcharge/charging-stations-map"} passHref legacyBehavior>
          <StyledButton
            variant="contained"
            onClick={() => trackEventByNameAndCategory('open_map', TrackMapSource.MOBILE)} >
            למפת עמדות טעינה

          </StyledButton>
        </Link>
        <StyledButtonYellow href={oneLinkUrl} variant="contained" onClick={() => {
          trackDownloadApp();
        }}>
          לאפליקציית yellow
        </StyledButtonYellow>
      </StyledButtonWrapper>
    </Mobile >
  );
}

export default StickyButtonNav;
